import { OrderStatuses } from '@tradingblock/types';
export const CancellableStatuses = [
    OrderStatuses.New,
    OrderStatuses.PartiallyFilled,
    OrderStatuses.Replaced,
    OrderStatuses.PendingCancel,
    OrderStatuses.PendingNew,
    OrderStatuses.PendingReplace,
    OrderStatuses.Saved,
    OrderStatuses.Initiated,
    OrderStatuses.ReplaceInitiated,
    OrderStatuses.CancelInitiated,
    OrderStatuses.CancelInitiated,
    OrderStatuses.CancelRejected,
    OrderStatuses.ReplaceRejected,
];
export const ReplaceableStatuses = [
    OrderStatuses.New,
    OrderStatuses.Replaced,
    OrderStatuses.PendingReplace,
    OrderStatuses.Saved,
    OrderStatuses.Initiated,
    OrderStatuses.ReplaceInitiated,
    OrderStatuses.ReplaceRejected,
];
export const OrderFilledStatuses = [
    OrderStatuses.Filled,
    OrderStatuses.PartiallyFilled,
    OrderStatuses.PartiallyCancelled,
];
export const ExecutedStatuses = [OrderStatuses.Filled, OrderStatuses.PartiallyFilled];
export const OpenStatuses = [
    OrderStatuses.New,
    OrderStatuses.PendingNew,
    OrderStatuses.Replaced,
    OrderStatuses.PendingReplace,
    OrderStatuses.Saved,
    OrderStatuses.Initiated,
    OrderStatuses.ReplaceInitiated,
    OrderStatuses.CancelInitiated,
    OrderStatuses.CancelRejected,
    OrderStatuses.ReplaceRejected,
];
export const OrderStatusCategories = {
    Cancellable: CancellableStatuses,
    Replaceable: ReplaceableStatuses,
    Filled: OrderFilledStatuses,
    Executed: ExecutedStatuses,
    Open: OpenStatuses,
};
export const PriorityOrderStatuses = [
    OrderStatuses.Initiated,
    OrderStatuses.Acknowledged,
    OrderStatuses.PendingNew,
    OrderStatuses.New,
    OrderStatuses.PartiallyFilled,
    OrderStatuses.ReplaceInitiated,
    OrderStatuses.PendingReplace,
    OrderStatuses.ReplaceRejected,
    OrderStatuses.Replaced,
    OrderStatuses.CancelInitiated,
    OrderStatuses.PendingCancel,
    OrderStatuses.CancelRejected,
    OrderStatuses.PartiallyCancelled,
    OrderStatuses.DoneForDay,
    OrderStatuses.Rejected,
    OrderStatuses.Cancelled,
    OrderStatuses.Expired,
    OrderStatuses.Saved,
    OrderStatuses.Filled,
];
//# sourceMappingURL=orderStatusCategories.js.map